import React, { useState } from 'react';
import '../styles/ScriptsView.css';
import { motion } from 'framer-motion';
import { Phone, Copy, MessageCircle, CheckCircle, AlertCircle } from 'lucide-react';

const ScriptsView = ({ showToast }) => {
  const [activeCategory, setActiveCategory] = useState('opening');

  const scriptData = {
    opening: [
      { id: 1, title: "Standard Greeting", text: "Hello, thank you for calling IT Support. My name is [Your Name], how can I help you today?" },
      { id: 2, title: "Answering Transfer", text: "Hello, this is [Your Name] from the Support Team. I understand you're experiencing issues with [Issue Name]. Let me help you with that." }
    ],
    troubleshooting: [
      { id: 3, title: "Asking for Remote Access", text: "In order to resolve this quickly, may I have your permission to start a remote session to view your screen?" },
      { id: 4, title: "Clarifying Questions", text: "Could you please tell me exactly what error message appeared on your screen when the issue occurred?" }
    ],
    closing: [
      { id: 5, title: "Standard Closing", text: "Is there anything else I can assist you with today? Thank you for calling, and have a great day!" },
      { id: 6, title: "Ticket Follow-up", text: "I have documented this in ticket #[ID]. You will receive an email confirmation shortly. Please reply to that email if the issue persists." }
    ]
  };

  const copyScript = (text) => {
    navigator.clipboard.writeText(text);
    if (showToast) showToast("Script copied to clipboard!", "success");
  };

  return (
    <motion.div 
      initial={{ opacity: 0, x: 20 }} 
      animate={{ opacity: 1, x: 0 }} 
      className="scripts-wrapper"
    >
      <div className="view-header">
        <div>
          <h2>Call Script Library</h2>
          <p>Standardized communication templates for support calls.</p>
        </div>
        <Phone size={32} color="#6366f1" opacity={0.5} />
      </div>

      <div className="script-tabs-container">
        {Object.keys(scriptData).map((cat) => (
          <button 
            key={cat}
            className={`script-tab-btn ${activeCategory === cat ? 'active' : ''}`}
            onClick={() => setActiveCategory(cat)}
          >
            {cat.charAt(0).toUpperCase() + cat.slice(1)}
          </button>
        ))}
      </div>

      <div className="scripts-grid">
        {scriptData[activeCategory].map((script) => (
          <motion.div 
            layout
            key={script.id} 
            className="script-card"
          >
            <div className="script-card-top">
              <div className="script-icon">
                {activeCategory === 'opening' && <MessageCircle size={16} />}
                {activeCategory === 'troubleshooting' && <AlertCircle size={16} />}
                {activeCategory === 'closing' && <CheckCircle size={16} />}
              </div>
              <h4>{script.title}</h4>
              <button className="copy-btn" onClick={() => copyScript(script.text)}>
                <Copy size={14} />
              </button>
            </div>
            <p className="script-body">"{script.text}"</p>
          </motion.div>
        ))}
      </div>
    </motion.div>
  );
};

export default ScriptsView;